import * as TimehseetTypes from "../types/timesheet.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";

export const loadTimesheet = (filter: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });

  axiosInstance
    .get("/timesheet/", { params: { ...filter } })
    .then((res) => {
      dispatch({
        type: TimehseetTypes.LOAD_TIMESHEET,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    })
    .finally(() => {
      dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
    });
};

export const loadInvoices = () => (dispatch: any) => {
  axiosInstance
    .get("xero/invoice-types")
    .then((res) => {
      dispatch({
        type: TimehseetTypes.LOAD_TIMESHEET_INVOICES,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};
export const loadPayrolls = () => (dispatch: any) => {
  axiosInstance
    .get("xero/payroll-types")
    .then((res) => {
      dispatch({
        type: TimehseetTypes.LOAD_TIMESHEET_PAYROLLS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const loadRegions = () => (dispatch: any) => {
  axiosInstance
    .get("xero/tracking-categories")
    .then((res) => {
      dispatch({
        type: TimehseetTypes.LOAD_TIMESHEET_REGIONS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};
export const loadScheduleList =
  (employeeId: string, mainParentId: string, subfacilityId?: string) =>
  (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    if (employeeId && mainParentId)
      axiosInstance
        .get(
          subfacilityId
            ? `/timesheet/schedules/${employeeId}/${mainParentId}/${subfacilityId}`
            : `/timesheet/schedules/${employeeId}/${mainParentId}`
        )
        .then((res) => {
          dispatch({ type: UiTypes.CLEAR_ERRORS });
          dispatch({
            type: TimehseetTypes.TIMESHEET_SCHEDULE_LIST,
            payload: res.data.data,
          });
        })
        .catch((err) => {
          if (err?.response?.status === 0) {
            dispatch({
              type: UiTypes.SET_ERRORS,
              payload: "Server Error. Please try later.",
            });
          } else {
            dispatch({
              type: UiTypes.SET_ERRORS,
              payload: "Network Issue",
            });
          }
          dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
        });
  };

export const getTimesheet = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: TimehseetTypes.FETCH_TIMESHEET_REQUEST });

  axiosInstance
    .get("timesheet/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: TimehseetTypes.FETCH_TIMESHEET_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const trashTimesheet = (id: any, filterData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/timesheet/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete Success"));

      dispatch(loadTimesheet(filterData));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error deleting data"));
    });
};

export const blukTrashTimesheet = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/timesheet/", id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete Success"));

      // dispatch(loadTimesheet(1))
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error deleting data"));
    });
};

/* export const updateTimesheet = (userData: any, id:number ) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI })
  dispatch({type:TimehseetTypes.TIMESHEET_SAVE_REQUEST})
  
  axiosInstance.put('timesheet/'+ id, userData)
    .then( (res ) => {
      dispatch({type:UiTypes.CLEAR_ERRORS});
      dispatch({type:TimehseetTypes.TIMESHEET_SAVE_SUCCESS});
      dispatch(alertActions.success('Updated Successfully'))
      dispatch(loadTimesheet(1))
    })
    .catch((err) => {
      if(err.response.status === 0) {
        dispatch({
          type:UiTypes.SET_ERRORS,
          payload: 'Server Error. Please try later.'
        })
      } else{

        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type:UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString()
        })
      }
      
    })
}
 */

export const addStaff = (userData: any, id: number) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });

  axiosInstance
    .post("timesheet/", userData)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_SUCCESS });
      dispatch(alertActions.success("Staff added Successfully"));
      //dispatch(loadTimesheet(1))
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const getTimesheetProfile = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: TimehseetTypes.FETCH_TIMESHEET_REQUEST });

  axiosInstance
    .get("timesheet/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: TimehseetTypes.FETCH_TIMESHEET_REQUEST_SUCCESS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const updateTimesheetProfile =
  (userData: any, id: number) => (dispatch: any) => {
    dispatch({ type: TimehseetTypes.PROFILE_SAVE_REQUEST });

    // userData.set('infos', JSON.parse(userData.get('infos')));

    axiosInstance
      .put("timesheet/" + id, userData)
      .then((res) => {
        dispatch(alertActions.success("Timesheet Updated Successfully"));
        dispatch({ type: TimehseetTypes.PROFILE_SAVE_SUCCESS });
        getTimesheetProfile(id);
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const updateTimesheetStatus =
  (userData: any, id: number) => (dispatch: any) => {
    dispatch({ type: TimehseetTypes.PROFILE_SAVE_REQUEST });

    axiosInstance
      .put("timesheet/status/" + id, userData)
      .then((res) => {
        dispatch(alertActions.success("Updated Successfully"));
        dispatch({ type: TimehseetTypes.PROFILE_SAVE_SUCCESS });
        getTimesheetProfile(id);
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const loadUserNameList = (term: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .get("/timesheet/employeesname?term=" + term)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: TimehseetTypes.TIMESHEET_EMPLOYEE_NAME_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const loadFacitlies = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .get("/timesheet/facilities")
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: TimehseetTypes.TIMESHEET_EMPLOYEE_FACILITIES,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const checkWorkLimit =
  (employeeId: string, formData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });

    axiosInstance
      .get(`timesheet/check-work-limit/${employeeId}`)
      .then((res) => {
        console.log(res, "response");
        if (res?.data?.data?.user_working_limit)
          dispatch(saveTimesheet(formData, filterData));
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, ""));
      });
  };

export const saveTimesheet =
  (userData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });

    axiosInstance
      .post("timesheet/sysclockin", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_SUCCESS });
        dispatch(alertActions.success("Timesheet created Successfully"));
        dispatch(loadTimesheet(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.message));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.message,
          });
        }
      });
  };

export const clockoutTimesheet =
  (userData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });

    axiosInstance
      .post("timesheet/sysclockout", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_SUCCESS });
        dispatch(alertActions.success("Timesheet updated Successfully"));
        dispatch(loadTimesheet(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.message));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.message,
          });
        }
      });
  };

export const updateTimesheetFacility =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });

    axiosInstance
      .put("timesheet/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_SUCCESS });
        dispatch(alertActions.success("Updated Successfully"));
        dispatch(loadTimesheet(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export interface UpdatePayrollFormType extends FormData {
  id: string;
  payroll_type: string;
}
export const updatePayrollChange =
  (
    formData: UpdatePayrollFormType,
    filterData: any,
    id: string,
    payroll_type: string
  ) =>
  (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });

    axiosInstance
      .put("timesheet/payroll", formData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Updated Successfully"));

        dispatch({
          type: TimehseetTypes.REPLACE_SELECTED_TIMESHEET_PAYROLL,
          payload: { id, payroll_type },
        });
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, ""));
        dispatch({ type: TimehseetTypes.RESTORE_TIMESHEETS });
      })
      .finally(() => {
        dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
        dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      });
  };

export interface updateInvoiceFormType extends FormData {
  id: string;
  invoice_type: string;
}

export const updateInvoiceChange =
  (
    formData: updateInvoiceFormType,
    filterData: any,
    id: string,
    invoice_type: string
  ) =>
  (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });

    axiosInstance
      .put("timesheet/invoice", formData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Updated Successfully"));

        dispatch({
          type: TimehseetTypes.REPLACE_SELECTED_TIMESHEET_INVOICE,
          payload: { id, invoice_type },
        });
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, ""));
        dispatch({ type: TimehseetTypes.RESTORE_TIMESHEETS });
      })
      .finally(() => {
        dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
        dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      });
  };

export const updateRegionChange =
  (
    formData: updateInvoiceFormType,
    filterData: any,
    id: string,
    region: string
  ) =>
  (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });

    axiosInstance
      .put("timesheet/region", formData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Updated Successfully"));

        dispatch({
          type: TimehseetTypes.REPLACE_SELECTED_TIMESHEET_REGION,
          payload: { id, region },
        });
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, ""));
        dispatch({ type: TimehseetTypes.RESTORE_TIMESHEETS });
      })
      .finally(() => {
        dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
        dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      });
  };
// export const updateInvoice =
//   (formData: UpdatePayrollFormType, filterData: any) => (dispatch: any) => {
//     dispatch({ type: UiTypes.LOADING_UI });

//     axiosInstance
//       .put("timesheet/payroll", formData)
//       .then((res) => {
//         dispatch({ type: UiTypes.CLEAR_ERRORS });
//         dispatch(alertActions.success("Updated Successfully"));
//         dispatch(loadTimesheet(filterData));
//       })
//       .catch((err) => {
//         if (err.response.status === 0) {
//           dispatch({
//             type: UiTypes.SET_ERRORS,
//             payload: "Server Error. Please try later.",
//           });
//         } else {
//           dispatch(alertActions.error(err.response.data.detail.toString()));
//           dispatch({
//             type: UiTypes.SET_ERRORS,
//             payload: err.response.data.detail.toString(),
//           });
//         }
//       });
//   };

export const updateTimesheet =
  (userData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });

    axiosInstance
      .post("timesheet/update", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_SUCCESS });
        dispatch(alertActions.success("Timesheet updated Successfully"));
        dispatch(loadTimesheet(filterData));
      })
      .catch((err) => {
        if (err.response && err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.message));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.message,
          });
        }
      });
  };

export const bulkTimesheetDelete = (formData: any) => (dispatch: any) => {
  dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });

  axiosInstance
    .delete("timesheet", { data: formData })
    .then((res) => {
      dispatch(loadTimesheet({ page: 1, size: 10 }));
    })
    .catch((err) => {
      if (err?.response?.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.data?.message) {
        dispatch(alertActions.error(err.response.data.message.toString()));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message.toString()));
      } else if (err?.message)
        dispatch(alertActions.error(err.message.toString()));
      else {
        dispatch(alertActions.error("Failed to delete."));
      }
      dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
    });
};

export const generateInvoice =
  (formData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });
    axiosInstance
      .post("xero/create-invoice", formData)
      .then((res) => {
        // dispatch({ type: UiTypes.CLEAR_ERRORS });

        dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_SUCCESS });
        dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
        res?.data?.success_messages?.forEach((successMessage: string) => {
          setTimeout(() => {
            dispatch(alertActions.success(successMessage));
          }, 0);
        });
        res?.data?.error_messages?.forEach((errorMessage: string) => {
          setTimeout(() => {
            dispatch(alertActions.error(errorMessage));
          }, 0);
        });
      })
      .catch((err) => {
        dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
        if (err?.data?.error_messages) {
          err?.data?.error_messages?.forEach((errorMessage: string) => {
            setTimeout(() => {
              dispatch(alertActions.error(errorMessage));
            }, 0);
          });
        }
        dispatch(alertActions.showError(err, "Create invoice failed"));
      });
  };

export const requestPayroll = (filterData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });
  axiosInstance
    .get("timesheet/request-payroll")
    .then((res) => {
      // dispatch({ type: UiTypes.CLEAR_ERRORS });

      dispatch({
        type: TimehseetTypes.LOAD_REQUESTED_PAYROLL_TIMESHEETS,
        payload: res.data,
      });
      dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
    })
    .catch((err) => {
      dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });

      // dispatch(alertActions.showError(err, "Create invoice failed"));
    });
};
export const createPayroll = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: TimehseetTypes.LOADING_TIMESHEET });

  dispatch({ type: TimehseetTypes.TIMESHEET_SAVE_REQUEST });
  axiosInstance
    .get("xero/create-payslips")
    .then((res) => {
      dispatch(alertActions.success("Created payroll successfully."));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Create payroll failed"));
    })
    .finally(() => {
      dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      dispatch({ type: TimehseetTypes.LOADING_TIMESHEET_SUCCESS });
    });
};
